<div [formGroup]="formGroup">
  <mat-form-field>
    <mat-label>{{ startFormLabel }}</mat-label>
    <mtx-datetimepicker
      #startDatetimePicker
      [type]="type"
      mode="portrait"
      timeInput
    ></mtx-datetimepicker>
    <input
      [mtxDatetimepicker]="startDatetimePicker"
      [formControlName]="startFormControlName"
      [placeholder]="placeholder"
      matInput
    />
    <mtx-datetimepicker-toggle
      [for]="startDatetimePicker"
      matSuffix
    ></mtx-datetimepicker-toggle>

    @if (
      formGroup.controls[startFormControlName].errors?.["required"] ||
      formGroup.controls[startFormControlName].errors?.[
        "mtxDatetimepickerParse"
      ]
    ) {
      <mat-error>{{ startErrorLabel }}を入力してください。</mat-error>
    }
  </mat-form-field>

  <span class="tw-mx-2">~</span>

  <mat-form-field>
    <mat-label>{{ endFormLabel }}</mat-label>
    <mtx-datetimepicker
      #endDatetimePicker
      [type]="type"
      mode="portrait"
      timeInput
    ></mtx-datetimepicker>
    <input
      [mtxDatetimepicker]="endDatetimePicker"
      [formControlName]="endFormControlName"
      [placeholder]="placeholder"
      matInput
    />
    <mtx-datetimepicker-toggle
      [for]="endDatetimePicker"
      matSuffix
    ></mtx-datetimepicker-toggle>

    @if (
      formGroup.controls[endFormControlName].errors?.["required"] ||
      formGroup.controls[endFormControlName].errors?.["mtxDatetimepickerParse"]
    ) {
      <mat-error>{{ endErrorLabel }}を入力してください。</mat-error>
    }
  </mat-form-field>
</div>

<div class="tw-text-xs">
  @if (
    formGroup.errors?.["startDateBeforeEndDate"] ||
    formGroup.errors?.["startDateBeforeEndDatetime"] ||
    formGroup.errors?.["startDateBeforeOptionalEndDatetime"]
  ) {
    <mat-error>
      <span>{{ startErrorLabel }}は{{ endErrorLabel }}よりも</span>
      <span>前の{{ timeUnitLabel }}を指定してください。</span>
    </mat-error>
  } @else if (maxRangeMonths && formGroup.errors?.["maxMonths"]) {
    <mat-error>
      <span>{{ startErrorLabel }}と{{ endErrorLabel }}の間隔は</span>
      <span>{{ maxRangeMonths }}か月以内にしてください。</span>
    </mat-error>
  } @else if (maxRangeDays && formGroup.errors?.["maxRangeExceeded"]) {
    <mat-error>
      <span>{{ startErrorLabel }}と{{ endErrorLabel }}の間隔は</span>
      <span>{{ maxRangeDays }}日以内にしてください。</span>
    </mat-error>
  } @else if (
    formGroup.controls[endFormControlName].errors?.[
      "datetimeBeforeNowDateTime"
    ] ||
    formGroup.controls[startFormControlName].errors?.[
      "datetimeBeforeNowDateTime"
    ]
  ) {
    <mat-error>
      <span>{{ startErrorLabel }}もしくは{{ endErrorLabel }}は</span>
      <span
        >現在の{{ timeUnitLabel }}よりも後の{{
          timeUnitLabel
        }}を指定してください。</span
      >
    </mat-error>
  }
</div>
